import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import AgentIntegrationSection from "../../../../contents/docs/components/AgentIntegrationSection.mdx";
import SvelteInstallClient from "../../../../contents/docs/integrate/_snippets/install-svelte-client.mdx";
import SvelteInstallServer from "../../../../contents/docs/integrate/_snippets/install-svelte-server.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  DetailPostHogIPs,
  AgentIntegrationSection,
  SvelteInstallClient,
  SvelteInstallServer,
  React
};